// extracted by mini-css-extract-plugin
module.exports = {"container":"article-card_container__3KvlH","content":"article-card_content__Jfwp2","title":"article-card_title__1B5pN","preview":"article-card_preview__13cLw"};